export enum GlobalStrings {
  GLOBAL_PROJECT_NAME = 'Schoolyard Social',
}

export enum AlertMessages {
  LOCATION_COPIED_TO_CLIPBOARD = 'Event Location was successfully copied to clipboard!',
  VERIFICATION_CODE_SENT_SUCCESS = 'Verification code sent to your phone number successfully!',
  VERIFICATION_CODE_RESENT_SUCCES = 'Verification code was resent successfully!',
}

export enum ButtonStrings {
  BUTTON_SIGN_UP = 'Sign Up',
  BUTTON_SHOW_MORE = 'show more',
  BUTTON_SHOW_LESS = 'show less',
  BUTTON_CONTINUE = 'Continue',
  BUTTON_RESEND = 'Resend',
  BUTTON_RESEND_IN = 'Resend in',
  BUTTON_PAY_NOW_WITH_FEE = 'Pay Now - $',
  BUTTON_INSTALL_APP = 'Install App',
}

export const REGEX_WHITESPACE = /^\S+$/;

export enum UserActionsMenuStrings {
  DELETE_USER_TITLE = 'Delete User',
  DELETE_USER_DESCRIPTION = 'Are you sure you want to delete this user? This action cannot be undone.',
  EDIT_USER = 'Edit',
  DELETE_USER = 'Delete',
}

export enum EventDetailStrings {
  WIN = 'Win',
  CASH_PRIZE = 'Cash Prize',
  CHARITY = 'Charity',
  ANNOUNCEMENT = 'Announcement',
  DESCRIPTION = 'Description',
  SKILL_LEVEL = 'Skill Level',
  LOCATION = 'Location',
  ENTRY_FEE = 'Entry Fee',
  FREE = 'Free',
  DATE = 'Date',
  START = 'Start: ',
  END = 'End: ',
  REGISTER_BY = 'Register by: ',
  HOST = 'Host',
  ACCESSIBILITY_IOS_DOWNLOAD = 'Download on AppStore',
  ACCESSIBILITY_ANDROID_DOWNLOAD = 'Get it on Playstore',
  SIGN_UP_MORE_INFO = 'Download the app to see full list of participants, check in, track scores, claim your victories & more.',
  SIGN_UP_SUCCESS = 'You successfully signed up',
  ACCESSIBILITY_SIGN_UP_SUCCESS = 'Sign up success',
  NO_DESCRIPTION = 'No description available.',
  HOST_RATING = 'host rating',
}

export enum UserFormStrings {
  USER_FORM_ERROR_EMAIL_REQUIRED = 'Email is required',
  USER_FORM_ERROR_EMAIL_INVALID = 'Invalid email',
}

export enum MobileAppBannerStrings {
  DOWNLOAD_APP = 'Download App',
}

export enum EventSignUpStrings {
  PHONE_NUMBER = 'Phone Number',
  EMAIL = 'Email',
}

export enum ErrorMessageStrings {
  DUPLICATE_PHONE = 'user with phone already exists',
  FAILED_TO_SIGN_UP = 'Failed to Sign Up User',
}

export enum FormValidationStrings {
  FULLNAME_REQUIRED = 'Full name is required',
  PHONE_REQUIRED = 'Phone is required',
  INVALID_PHONE = 'Phone number is invalid',
  REASON_REQUIRED = 'Reason is required',
}

export enum VerifyOtpStrings {
  TITLE = 'Verification Code',
  ENTER_CODE = 'Enter Code',
  DESCRIPTION = ' We sent a code to your number for verification.',
  MINS = 'mins',
  SECS = 'secs',
  SEC = 'sec',
}

export enum DeleteAccountStrings {
  TITLE = 'Delete Your Account',
  DESCRIPTION = 'Request deletion of your Schoolyard Social account and the data associated with it. Submit the form below and our support team will process your request.',
  FULL_NAME = 'Full Name',
  FULL_NAME_PLACEHOLDER = 'Enter the full name on your account',
  EMAIL = 'Email',
  EMAIL_PLACEHOLDER = 'Enter the email address on your account',
  PHONE = 'Phone Number',
  PHONE_PLACEHOLDER = 'Enter the phone number on your account',
  REASON = 'Reason for Deletion',
  REASON_PLACEHOLDER = 'Tell us why you want to delete your account',
  SUBMIT = 'Submit Request',
  SUBMITTING = 'Submitting...',
  WHAT_HAPPENS_TITLE = 'What happens when your account is deleted',
  DELETED_TITLE = 'Permanently deleted',
  DELETED_CONTACT = 'Your email address, phone number, password, and gender.',
  DELETED_PROFILE = 'Your profile: name, username, bio, profile photo, city, state, street address, ZIP code, saved location, and social media links.',
  DELETED_PAYMENT = 'Your payout details and the customer records we hold with our payment providers.',
  RETAINED_TITLE = 'Retained',
  RETAINED_ACTIVITY = 'Activity you took part in — event sign-ups, match results, ratings, chat messages, and photos you uploaded — stays in the app so other participants\u2019 records remain intact. It is no longer shown with your name, username, or profile photo.',
  RETAINED_RECORDS = 'Payment and transaction records we are required to keep for tax, accounting, and fraud-prevention purposes, as described in our Privacy Policy.',
  WHAT_HAPPENS_TIMING = 'Requests are processed within 30 days. We may contact you at the email above to confirm the request.',
  SUCCESS_TITLE = 'Request Received',
  SUCCESS_DESCRIPTION = 'We received your account deletion request. Our support team will email you at the address you provided once it has been processed.',
  ERROR = 'We could not submit your request. Please try again or email support@schoolyardsocial.co.',
  SUPPORT_PREFIX = 'Questions? Contact us at ',
  SUPPORT_EMAIL = 'support@schoolyardsocial.co',
}
